import { useQuery } from "react-query";
import { getOfficePhones } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useOfficePhones = () => {
  return useQuery("GetOfficePhones", getOfficePhones, {
    refetchOnWindowFocus: false,
  });
};
